import { Anchor, Button } from '../Button/Button.js';
import * as S from './CallToAction.styles.js';
import { Layout } from '@/components/Layout/Layout.js';
import { FadeUpInView } from '@/components/Motion/Fade/FadeUpInView/FadeUpInView.js';
import { StaggerText } from '@/components/Motion/StaggerText/StaggerText.js';
import { useInquiry } from '@/hooks/useInquiry.js';
import { useMatchMedia } from '@/hooks/useMatchMedia.js';
import { useViewServicesCTA } from '@/hooks/useViewServicesCTA.js';
import { minWidthMediaQueries } from '@/stitches/media.js';
import { type CallToActionProps } from '@/types/callToAction.js';

export const CallToAction = ({
  buttonLabel,
  fontFamily,
  title,
  variant,
  ...props
}: CallToActionProps) => {
  const { getInquiryButtonProps, userProfileIsReceivingInquiries } =
    useInquiry();
  const servicesLinkProps = useViewServicesCTA();
  const isMediumViewport = useMatchMedia(minWidthMediaQueries.bp2);

  if (!userProfileIsReceivingInquiries && variant === 'inquiry') return null;

  return (
    <Layout.FullWidth
      css={{ '> div:first-child': { zIndex: -1 } }}
      id="inquiry"
    >
      <S.Container>
        <S.Title fontFamily={fontFamily}>
          {isMediumViewport ? <StaggerText>{title}</StaggerText> : <>{title}</>}
        </S.Title>
        <FadeUpInView delay={0.8}>
          {variant === 'services' ? (
            <Anchor
              aria-label={buttonLabel}
              {...servicesLinkProps}
              variant="inverted"
            >
              {buttonLabel}
            </Anchor>
          ) : null}
          {variant === 'inquiry' && 'section' in props ? (
            <Button
              aria-label={buttonLabel}
              type="button"
              {...getInquiryButtonProps({ section: props.section })}
              css={{
                textTransform: 'uppercase',
              }}
              variant="inverted"
            >
              {buttonLabel}
            </Button>
          ) : null}
        </FadeUpInView>
      </S.Container>
    </Layout.FullWidth>
  );
};
